import { render, staticRenderFns } from "./LogicShow.vue?vue&type=template&id=cb3bc2c6&scoped=true&"
import script from "./LogicShow.vue?vue&type=script&lang=js&"
export * from "./LogicShow.vue?vue&type=script&lang=js&"
import style0 from "./LogicShow.vue?vue&type=style&index=0&id=cb3bc2c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3bc2c6",
  null
  
)

export default component.exports